module.exports = __webpack_public_path__ + "static/img/kv.7c51f22.png";


//////////////////
// WEBPACK FOOTER
// ./static/circle/kv.png
// module id = sAKy
// module chunks = 1